module.exports = __webpack_public_path__ + "static/media/country_kp.ff049902.webp";